export const FILE_DOWNLOAD_REQUESTED = 'FILE_DOWNLOAD_REQUESTED';
export const FILE_DOWNLOAD_SUCCEEDED = 'FILE_DOWNLOAD_SUCCEEDED';
export const FILE_DOWNLOAD_FAILED = 'FILE_DOWNLOAD_FAILED';